/**
 * Tomaruba Guest API
 * Tomaruba Guest API
 *
 * OpenAPI spec version: 1.0.0
 * Contact: development@tomaruba.me
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient'

/**
 * The InvoiceAutomation model module.
 * @module model/InvoiceAutomation
 * @version 1.0.0
 */
export default class InvoiceAutomation {
  /**
   * Constructs a new <code>InvoiceAutomation</code>.
   * @alias module:model/InvoiceAutomation
   * @class
   */

  constructor() {}

  /**
   * Constructs a <code>InvoiceAutomation</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/InvoiceAutomation} obj Optional instance to populate.
   * @return {module:model/InvoiceAutomation} The populated <code>InvoiceAutomation</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new InvoiceAutomation()

      if (data.hasOwnProperty('account_id')) {
        obj['account_id'] = ApiClient.convertToType(data['account_id'], 'Number')
      }
      if (data.hasOwnProperty('status')) {
        obj['status'] = ApiClient.convertToType(data['status'], 'String')
      }
      if (data.hasOwnProperty('min_price')) {
        obj['min_price'] = ApiClient.convertToType(data['min_price'], 'Number')
      }
    }
    return obj
  }

  /**
   * @member {Number} account_id
   */
  account_id = undefined
  /**
   * @member {module:model/InvoiceAutomation.StatusEnum} status
   */
  status = undefined
  /**
   * @member {Number} min_price
   */
  min_price = undefined

  /**
   * Allowed values for the <code>status</code> property.
   * @enum {String}
   * @readonly
   */
  static StatusEnum = {
    /**
     * value: "disabled"
     * @const
     */
    disabled: 'disabled',

    /**
     * value: "manual"
     * @const
     */
    manual: 'manual',

    /**
     * value: "auto"
     * @const
     */
    auto: 'auto'
  }
}
